import { useState, useMemo } from 'react'
import styled from 'styled-components'
import { Box, Button, Flex, Heading, Link, Text, CKBIcon, Image, CardBody } from '@pancakeswap/uikit'
import { useWeb3React } from '@web3-react/core'
import { useTranslation } from 'contexts/Localization'
import PageHeader from 'components/PageHeader'
import PageSection from 'components/PageSection'
import { PageMeta } from 'components/Layout/Page'
import { useGetCollectionFromContract } from 'state/nftMarket/hooks'
import useTheme from 'hooks/useTheme'
import { mintList } from 'config/constants/mints'
import { AppBody } from 'components/App'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { AutoColumn } from 'components/Layout/Column'
import QuestionHelper from 'components/QuestionHelper'
import { useClock } from 'hooks/useClock'
import getTimePeriods from 'utils/getTimePeriods'
import { useCallWithGasPrice } from 'hooks/useCallWithGasPrice'
import { useTanukiContract } from 'hooks/useContract'
import { parseEther } from '@ethersproject/units'
import useToast from 'hooks/useToast'
import { ToastDescriptionWithTx } from 'components/Toast'
import { useGetBnbBalance } from 'hooks/useTokenBalance'
import { formatBigNumber } from 'utils/formatBalance'

const StyledPageHeader = styled(PageHeader)`
  margin-bottom: -40px;
  padding-bottom: 40px;
`

const StyledHeaderInner = styled(Flex)`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  & div#header1 {
    order: 1;
  }
  & div#header2 {
    order: 0;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    flex-direction: row;
    align-items: start;
    justify-content: space-between;

    & div#header1 {
      order: 0;
    }
    & div#header2 {
      order: 1;
    }
  }
`

const StyledText = styled(Text)`
  background: linear-gradient(to right, #e72e2d, #5467ff);
  -webkit-background-clip: text;
  color: transparent;
  font-size: 64px;
  font-weight: 600;
  line-height: 1.1;
`

const StyledLink = styled(Link)`
  color: white;
  text-decoration: underline;
  margin-right: 12px;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
`

const StyledImage = styled(Image)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  max-height: none;
  display: none;
  top: 0;
  overflow: hidden;

  ${({ theme }) => theme.mediaQueries.sm} {
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
      max-width: initial;
      height: auto;
      width: 900px;
      left: auto;
    }
  }

  ${({ theme }) => theme.mediaQueries.md} {
    & img {
      width: 1000px;
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    & img {
      width: 1100px;
    }
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    & img {
      width: 1200px;
    }
  }

  ${({ theme }) => theme.mediaQueries.xxl} {
    & img {
      max-width: 100%;
      height: auto;
      width: initial;
      left: 0;
    }
    max-width: 1200px;
  }
`

const AppWrapper = styled(Flex)`
  justify-content: center;
  padding: 32px 24px;

  @media screen and (max-width: 992px) {
  }

  @media screen and (max-width: 576px) {
    padding: 0px;
    width: 100%;
  }
`

const StyledAppBody = styled(AppBody)`
  background: #1c1b25;
  margin: 12px;
  width: 640px;

  @media screen and (max-width: 576px) {
    margin: 12px 0;
    width: 100%;
  }
`
const StyledCardBody = styled(CardBody)`
  background: #1c1b25;
`

const Wrapper = styled.div`
  position: relative;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
  background: #1c1b25;

  &::after {
    content: '';
    height: 4px;
    width: 100%;
    background: linear-gradient(268.76deg, #5467ff 6.69%, #e72e2d 96.47%);
  }
`

const ActiveText = styled.h1`
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
  color: #fff;
  background: -webkit-linear-gradient(120deg, #5467ff 6.69%, #e72e2d 96.47%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

const StyledMintList = styled(Flex)`
  background: ${(props) => {
    return props.itemProp === 'active' ? 'linear-gradient(268.76deg, #5467ff 6.69%, #e72e2d 96.47%)' : '#050313'
  }};
  flex-direction: column;
  border-radius: 12px;
`

const StyledMintListWrapper = styled(Flex)`
  background: ${(props) => {
    return props.itemProp === 'active' ? 'linear-gradient(268.76deg, #5467ff 6.69%, #e72e2d 96.47%)' : '#050313'
  }};
  padding: ${(props) => {
    return props.itemProp === 'active' ? '2px' : '0px'
  }};
  border-radius: 12px;
`

const StyledMintListContent = styled(Flex)`
  background: #272534;
  width: 100%;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 8px 16px;
  flex-direction: column;
`

const StyledMintListItem = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  background: #272534;
  width: 100%;
  padding: 10px 0px;

  :not(:last-child) {
    border-bottom: 1px #68667b solid;
  }
`

const StyledTimer = styled(Text)`
  border: 1px white solid;
  width: 28px;
  text-align: center;
  padding: 3px 4px;
  border-radius: 8px;
  font-size: 12px;

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 12px;
  }
`

const StyledTimerSeperator = styled(Text)`
  margin: 0px 4px;
  font-size: 24px;
  color: white;
  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 24px;
  }
`

const StyledTransparentButton = styled(Button)`
  background: transparent;
  font-size: 32px;
  font-weight: normal;
  color: #9f9ea6;
`

const StyledProjectImage = styled(Image)`
  width: 620px;
  height: 240px;
  border-radius: 12px;
  flex-shrink: 0;

  & img {
    border-radius: 12px;
  }

  @media screen and (max-width: 576px) {
    width: 100%;
    height: auto;
  }
`

const Home = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { theme } = useTheme()
  const { balance } = useGetBnbBalance()
  const activeMint = mintList.find((mint) => mint.isActive)

  const [numberOfMint, setNumberOfmint] = useState(1)
  const minus = () => {
    if (numberOfMint > 1) {
      setNumberOfmint(numberOfMint - 1)
    }
  }

  const plus = () => {
    if (numberOfMint < 10) {
      setNumberOfmint(numberOfMint + 1)
    }
  }

  const now = useClock()
  const isNotStarted = useMemo(() => now < activeMint.startTime, [now, activeMint.startTime])
  const isPresaleEnd = useMemo(() => now > activeMint.presaleEndTime, [now, activeMint.presaleEndTime])

  const isInsufficientSalePrice = useMemo(
    () => Number(formatBigNumber(balance, 2, 18)) < activeMint.salePrice,
    [balance, activeMint.salePrice],
  )
  const isInsufficientDiscountPrice = useMemo(
    () => Number(formatBigNumber(balance, 2, 18)) < activeMint.discountPrice,
    [balance, activeMint.discountPrice],
  )

  const estimatedSecondsLeft = useMemo(
    () => Math.max(0, (isNotStarted ? activeMint.startTime : activeMint.presaleEndTime) - now),
    [isNotStarted, now, activeMint.startTime, activeMint.presaleEndTime],
  )

  const {
    days: daysLeft,
    hours: hoursLeft,
    minutes: minutesLeft,
    seconds: secondsLeft,
  } = useMemo(() => getTimePeriods(estimatedSecondsLeft / 1000), [estimatedSecondsLeft])

  const presaleEndTimeSecondsLeft = useMemo(
    () => Math.max(0, activeMint.presaleEndTime - now),
    [now, activeMint.presaleEndTime],
  )

  const {
    days: daysLeftOfPresaleEnd,
    hours: hoursLeftOfPresaleEnd,
    minutes: minutesLeftOfPresaleEnd,
    seconds: secondsLeftOfPresaleEnd,
  } = useMemo(() => getTimePeriods(presaleEndTimeSecondsLeft / 1000), [presaleEndTimeSecondsLeft])

  const { totalSupply, isWhitelistedUser, whitelistMinted, isDiscountUser, discountMinted, saleMinted } =
    useGetCollectionFromContract(activeMint.address, account)
  const soldPercentage = useMemo(
    () => ((Number(totalSupply) / activeMint.total) * 100).toFixed(2),
    [totalSupply, activeMint.total],
  )
  const isSoldout = useMemo(() => Number(totalSupply) >= activeMint.total, [totalSupply, activeMint.total])

  const { toastSuccess, toastError } = useToast()
  const { callWithGasPrice } = useCallWithGasPrice()
  const tanukiContract = useTanukiContract(activeMint.address, true)

  const handleFreetMint = async () => {
    try {
      const tx = await callWithGasPrice(tanukiContract, 'freeMint', [numberOfMint])
      const receipt = await tx.wait()
      if (receipt?.status) {
        toastSuccess(t('Mint Success'), <ToastDescriptionWithTx txHash={receipt.transactionHash} />)
      }
    } catch (error: any) {
      const msg = error.data?.message?.match("'(.*)'")[1]
      toastError('Mint Failed', msg || error.message)
    }
  }

  const handleDiscountMint = async () => {
    try {
      const tx = await callWithGasPrice(tanukiContract, 'discountMint', [numberOfMint], {
        value: parseEther((activeMint.discountPrice * numberOfMint).toString()),
      })
      const receipt = await tx.wait()
      if (receipt?.status) {
        toastSuccess(t('Mint Success'), <ToastDescriptionWithTx txHash={receipt.transactionHash} />)
      }
    } catch (error: any) {
      const msg = error.data?.message?.match("'(.*)'")[1]
      toastError('Mint Failed', msg || error.message)
    }
  }

  const handlePublicMint = async () => {
    try {
      const tx = await callWithGasPrice(tanukiContract, 'publicMint', [numberOfMint], {
        value: parseEther((activeMint.salePrice * numberOfMint).toString()),
      })
      const receipt = await tx.wait()
      if (receipt?.status) {
        toastSuccess(t('Mint Success'), <ToastDescriptionWithTx txHash={receipt.transactionHash} />)
      }
    } catch (error: any) {
      const msg = error.data?.message?.match("'(.*)'")[1]
      toastError('Mint Failed', msg || error.message)
    }
  }

  return (
    <>
      <PageMeta />
      <StyledPageHeader>
        <StyledHeaderInner>
          <Box id="header1">
            <Heading as="h1" scale="xxl" color="secondary" mb="24px">
              <Flex justifyContent="start" alignItems="center">
                <StyledText>{activeMint.name}</StyledText>
              </Flex>
            </Heading>
            <Heading scale="md" color="text">
              {activeMint.desc}
            </Heading>
            <Flex justifyContent="start" alignItems="center" color="text" mt="24px">
              <Flex justifyContent="start" alignItems="center">
                <Text fontSize="14px" mt="1px">
                  TOTAL ITEMS
                </Text>
                <Text fontSize="24px" fontWeight="bold" ml="10px">
                  {activeMint.total}
                </Text>
              </Flex>
              <Flex justifyContent="start" alignItems="center" ml="24px">
                <Text fontSize="14px" mt="1px">
                  PRICE
                </Text>
                <CKBIcon width="24px" height="24px" ml="10px" mr="4px" />
                <Text fontSize="24px" fontWeight="bold">
                  {activeMint.salePrice}
                </Text>
              </Flex>
            </Flex>
            <Flex flexWrap="wrap" justifyContent="flex-start" alignItems="center" mt="28px">
              {activeMint.twitter && (
                <StyledLink href={activeMint.twitter} target="_blank">
                  <Image
                    src="/images/mints/twitter.svg"
                    alt="Twitter"
                    width={24}
                    height={24}
                    style={{ width: '24px', height: '24px' }}
                  />
                </StyledLink>
              )}

              {activeMint.discord && (
                <StyledLink href={activeMint.discord} target="_blank">
                  <Image
                    src="/images/mints/discord.svg"
                    alt="Discord"
                    width={24}
                    height={24}
                    style={{ width: '24px', height: '24px' }}
                  />
                </StyledLink>
              )}

              {activeMint.medium && (
                <StyledLink href={activeMint.medium} target="_blank">
                  <Image
                    src="/images/mints/medium.svg"
                    alt="Medium"
                    width={24}
                    height={24}
                    style={{ width: '24px', height: '24px' }}
                  />
                </StyledLink>
              )}
            </Flex>
          </Box>
          <StyledProjectImage id="header2" src={activeMint.bannerImg} alt={activeMint.name} width={620} height={240} />
        </StyledHeaderInner>
      </StyledPageHeader>
      <PageSection
        innerProps={{ style: { margin: '0', width: '100%', paddingTop: '0px' } }}
        background="#050313"
        index={1}
        hasCurvedDivider={false}
      >
        <StyledImage src="/images/mints/bg.png" width={1440} height={500} />
        <Flex justifyContent="center" alignItems="center" mt="-30px">
          <Image src={activeMint.projectImg} width={300} height={300} />
        </Flex>
        <AppWrapper background="#050313">
          <StyledAppBody>
            <Wrapper>
              <Header>
                <Flex
                  justifyContent="space-between"
                  alignItems="center"
                  px={['16px', null, null, '32px']}
                  py={['12px', null, null, '24px']}
                >
                  <Flex alignItems="center">
                    <Flex flexDirection="column" alignItems="center">
                      <ActiveText>{t('Mint')}</ActiveText>
                    </Flex>
                  </Flex>
                </Flex>
              </Header>
              <StyledCardBody p={['16px', null, null, '32px']}>
                <AutoColumn gap="md">
                  <StyledMintList itemProp={!isPresaleEnd && !isNotStarted ? 'active' : 'normal'}>
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      px="16px"
                      py="4px"
                      width="100%"
                      height="44px"
                    >
                      <Flex justifyContent="start" alignItems="center">
                        <Text fontSize="16px" fontWeight="bold">
                          Presale
                        </Text>
                        <QuestionHelper
                          size="16px"
                          ml="8px"
                          mt="3px"
                          placement="top-start"
                          text={t(
                            'Free minting and WL minting are only open for 48 hours, from 26th August 2022 4am UTC to 28th August 2022 4am UTC. Free mint and whitelist users must mint within the specified time period or they forfeit their chance to mint. Whitelisted users must hold at least 1000 YOK as a prerequisite to participate in the mint.',
                          )}
                        />
                      </Flex>
                      <Flex justifyContent="start" alignItems="center">
                        {!isPresaleEnd ? (
                          <>
                            <Text fontSize="16px">{isNotStarted ? 'Start In' : 'Ends In'}</Text>
                            <Flex justifyContent="space-between" alignItems="center" ml="8px">
                              <Flex flexDirection="column" justifyContent="space-between" alignItems="center">
                                <StyledTimer>{daysLeft.toString().padStart(2, '0')}</StyledTimer>
                              </Flex>
                              <StyledTimerSeperator>:</StyledTimerSeperator>
                              <Flex flexDirection="column" justifyContent="space-between" alignItems="center">
                                <StyledTimer>{hoursLeft.toString().padStart(2, '0')}</StyledTimer>
                              </Flex>
                              <StyledTimerSeperator>:</StyledTimerSeperator>
                              <Flex flexDirection="column" justifyContent="space-between" alignItems="center">
                                <StyledTimer>{minutesLeft.toString().padStart(2, '0')}</StyledTimer>
                              </Flex>
                              <StyledTimerSeperator>:</StyledTimerSeperator>
                              <Flex flexDirection="column" justifyContent="space-between" alignItems="center">
                                <StyledTimer>{secondsLeft.toFixed(0).toString().padStart(2, '0')}</StyledTimer>
                              </Flex>
                            </Flex>
                          </>
                        ) : (
                          'Ended'
                        )}
                      </Flex>
                    </Flex>
                    <StyledMintListWrapper itemProp={!isPresaleEnd && !isNotStarted ? 'active' : 'normal'}>
                      <StyledMintListContent>
                        {activeMint.presale.map((item) => (
                          <StyledMintListItem key={item.name}>
                            <Flex flex={1} alignItems="center">
                              {item.name}
                            </Flex>
                            <Flex flex={1} alignItems="center">
                              PRICE <CKBIcon width="18px" height="18px" ml="8px" mr="4px" />{' '}
                              <Text fontSize="18px" fontWeight="bold" ml="8px">
                                {item.salePrice}
                              </Text>
                            </Flex>
                            <Flex flex={1} justifyContent="end" alignItems="center">
                              MAX{' '}
                              <Text fontSize="18px" fontWeight="bold" ml="8px">
                                {item.maxAmount}
                              </Text>
                            </Flex>
                          </StyledMintListItem>
                        ))}
                      </StyledMintListContent>
                    </StyledMintListWrapper>
                  </StyledMintList>
                  <StyledMintList itemProp={isPresaleEnd ? 'active' : 'normal'}>
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      px="16px"
                      py="4px"
                      width="100%"
                      height="44px"
                    >
                      <Flex justifyContent="start" alignItems="center">
                        <Text fontSize="16px">Public</Text>
                        <QuestionHelper
                          size="16px"
                          ml="8px"
                          mt="3px"
                          placement="top-start"
                          text={t(
                            'Users must hold at least 1000 YOK as a prerequisite to participate. Each wallet address can mint up to 10 NFTs.',
                          )}
                        />
                      </Flex>
                      {!isPresaleEnd && (
                        <Flex justifyContent="start" alignItems="center">
                          <Text fontSize="16px">Start In</Text>
                          <Flex justifyContent="space-between" alignItems="center" ml="8px">
                            <Flex flexDirection="column" justifyContent="space-between" alignItems="center">
                              <StyledTimer>{daysLeftOfPresaleEnd.toString().padStart(2, '0')}</StyledTimer>
                            </Flex>
                            <StyledTimerSeperator>:</StyledTimerSeperator>
                            <Flex flexDirection="column" justifyContent="space-between" alignItems="center">
                              <StyledTimer>{hoursLeftOfPresaleEnd.toString().padStart(2, '0')}</StyledTimer>
                            </Flex>
                            <StyledTimerSeperator>:</StyledTimerSeperator>
                            <Flex flexDirection="column" justifyContent="space-between" alignItems="center">
                              <StyledTimer>{minutesLeftOfPresaleEnd.toString().padStart(2, '0')}</StyledTimer>
                            </Flex>
                            <StyledTimerSeperator>:</StyledTimerSeperator>
                            <Flex flexDirection="column" justifyContent="space-between" alignItems="center">
                              <StyledTimer>
                                {secondsLeftOfPresaleEnd.toFixed(0).toString().padStart(2, '0')}
                              </StyledTimer>
                            </Flex>
                          </Flex>
                        </Flex>
                      )}
                    </Flex>
                    <StyledMintListWrapper itemProp={isPresaleEnd ? 'active' : 'normal'}>
                      <StyledMintListContent>
                        <StyledMintListItem>
                          <Flex flex={1} alignItems="center">
                            {activeMint.publicSale.name}
                          </Flex>
                          <Flex flex={1} alignItems="center">
                            PRICE <CKBIcon width="18px" height="18px" ml="8px" mr="4px" />{' '}
                            <Text fontSize="18px" fontWeight="bold" ml="8px">
                              {activeMint.publicSale.salePrice}
                            </Text>
                          </Flex>
                          <Flex flex={1} justifyContent="end" alignItems="center">
                            MAX{' '}
                            <Text fontSize="18px" fontWeight="bold" ml="8px">
                              {activeMint.publicSale.maxAmount}
                            </Text>
                          </Flex>
                        </StyledMintListItem>
                      </StyledMintListContent>
                    </StyledMintListWrapper>
                  </StyledMintList>

                  {!isNotStarted && (
                    <Flex flexDirection="column" justifyContent="start" alignItems="center" mt="24px">
                      <Flex justifyContent="end" alignItems="center" width="100%">
                        {!isSoldout ? (
                          <Text fontSize="12px" color="#9F9EA6">
                            {soldPercentage}% sold ({totalSupply}/{activeMint.total})
                          </Text>
                        ) : (
                          <Text fontSize="12px" color="#9F9EA6">
                            soldout
                          </Text>
                        )}
                      </Flex>
                      <Flex
                        justifyContent="start"
                        alignItems="center"
                        width="100%"
                        background="#272534"
                        borderRadius="12px"
                        height="12px"
                        mt="8px"
                      >
                        <Flex
                          justifyContent="start"
                          alignItems="center"
                          width={`${soldPercentage}%`}
                          background="#FF4342"
                          borderRadius="12px"
                          height="12px"
                        />
                      </Flex>
                    </Flex>
                  )}

                  {account &&
                    !isNotStarted &&
                    ((!isPresaleEnd &&
                      ((Boolean(isWhitelistedUser) && Number(whitelistMinted) < activeMint.presale[0].maxAmount) ||
                        (Boolean(isDiscountUser) && Number(discountMinted) < activeMint.presale[1].maxAmount))) ||
                      (isPresaleEnd && Number(saleMinted) < activeMint.publicSale.maxAmount)) && (
                      <Flex justifyContent="center" alignItems="center" mt="24px" mb="24px">
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          width="160px"
                          height="48px"
                          borderRadius="12px"
                          border="1px solid #34333E"
                          padding="0 8px"
                        >
                          <Flex width="40px" justifyContent="center" alignItems="center">
                            <StyledTransparentButton onClick={minus}>-</StyledTransparentButton>
                          </Flex>
                          <Flex width="40px" justifyContent="center" alignItems="center">
                            <Text fontSize="24px" fontWeight="bold">
                              {numberOfMint}
                            </Text>
                          </Flex>
                          <Flex width="40px" justifyContent="center" alignItems="center">
                            <StyledTransparentButton onClick={plus}>+</StyledTransparentButton>
                          </Flex>
                        </Flex>
                      </Flex>
                    )}

                  {account ? (
                    <>
                      {!isNotStarted && !isPresaleEnd && (
                        <>
                          {Boolean(isWhitelistedUser) && (
                            <>
                              {Number(whitelistMinted) < activeMint.presale[0].maxAmount ? (
                                <Button
                                  style={{
                                    background: 'linear-gradient(268.76deg, #5467ff 6.69%, #e72e2d 96.47%)',
                                    color: 'white',
                                  }}
                                  height="56px"
                                  width="100%"
                                  disabled={isPresaleEnd || isNotStarted}
                                  onClick={handleFreetMint}
                                >
                                  {isNotStarted
                                    ? 'Free Mint Not Start'
                                    : isPresaleEnd
                                    ? 'Free Mint Ended'
                                    : 'Free Mint'}
                                </Button>
                              ) : (
                                <Text textAlign="center">Max free mint amount exceeded.</Text>
                              )}
                            </>
                          )}

                          {Boolean(isDiscountUser) && (
                            <>
                              {Number(discountMinted) < activeMint.presale[1].maxAmount ? (
                                <Button
                                  style={{
                                    background: 'linear-gradient(268.76deg, #5467ff 6.69%, #e72e2d 96.47%)',
                                    color: 'white',
                                  }}
                                  height="56px"
                                  width="100%"
                                  disabled={isPresaleEnd || isNotStarted || isInsufficientDiscountPrice}
                                  onClick={handleDiscountMint}
                                >
                                  {isNotStarted
                                    ? isInsufficientDiscountPrice
                                      ? 'Insufficient Fund'
                                      : 'Discount Mint Not Start'
                                    : isPresaleEnd
                                    ? 'Discount Mint Ended'
                                    : 'Discount Mint'}
                                </Button>
                              ) : (
                                <Text textAlign="center">Max discount mint amount exceeded.</Text>
                              )}
                            </>
                          )}

                          {!isWhitelistedUser && !isDiscountUser && (
                            <Text textAlign="center">You are not in the presale list.</Text>
                          )}
                        </>
                      )}

                      {isPresaleEnd && (
                        <>
                          {Number(saleMinted) < activeMint.publicSale.maxAmount ? (
                            <Button
                              style={{
                                background: 'linear-gradient(268.76deg, #5467ff 6.69%, #e72e2d 96.47%)',
                                color: 'white',
                              }}
                              height="56px"
                              width="100%"
                              disabled={!isPresaleEnd || isInsufficientSalePrice}
                              onClick={handlePublicMint}
                            >
                              {isPresaleEnd
                                ? isInsufficientSalePrice
                                  ? 'Insufficient Fund'
                                  : 'Mint'
                                : 'Public Mint Not Start'}
                            </Button>
                          ) : (
                            <Text textAlign="center">Max public mint amount exceeded.</Text>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <ConnectWalletButton
                      style={{ background: 'linear-gradient(268.76deg, #5467ff 6.69%, #e72e2d 96.47%)' }}
                      height="56px"
                      width="100%"
                    />
                  )}
                </AutoColumn>
              </StyledCardBody>
            </Wrapper>
          </StyledAppBody>
        </AppWrapper>
      </PageSection>
    </>
  )
}

export default Home
